import React, { useEffect, useState } from "react";
import { Image, Progress } from "antd";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { authSVC } from "../../services";
import { useB2BContext } from "../../context/ContextB2B";
import "./Deptgrid.scss";

export default function Deptgrid() {
  const navigate = useNavigate();
  const [tapIndex2, setTapIndex2] = useState<number>(0);
  const { getUserByID } = useB2BContext();

  const [departmentWellnessLevel, setdepartmentWellnessLevel] = useState<any[]>([]);
  const [departmentHappinessLevel, setdepartmentHappinessLevel] = useState<any[]>([]);

  useEffect(() => {
    const month: any = moment().format("M");
    const year: any = moment().format("yyyy");
    if (getUserByID) {
      authSVC
        .getDepartmentLevels(getUserByID?.company, Number(month), Number(year))
        .then((res) => setdepartmentWellnessLevel(res?.data?.data))
        .catch((err) => console.log(err));

      authSVC
        .getDepartmentHappinessLevels(getUserByID?.company, Number(month), Number(year))
        .then((res) => setdepartmentHappinessLevel(res?.data?.data))
        .catch((err) => console.log(err));
    }
  }, [getUserByID]);

  const activeData = tapIndex2 === 0 ? departmentWellnessLevel : departmentHappinessLevel;
  const isEmpty = departmentWellnessLevel.length === 0;

  return (
    <div className="dept-card">

      {/* ── Header ──────────────────────────────────────────── */}
      <div className="dept-card__header">
        <div className="dept-card__header-top">

          {/* Tab toggle */}
          <div className="dept-card__tabs">
            <button
              className={`dept-card__tab ${tapIndex2 === 0 ? "dept-card__tab--active" : ""}`}
              onClick={() => setTapIndex2(0)}
            >
              <span
                className="dept-card__tab-dot"
                style={{ background: tapIndex2 === 0 ? "#9EC655" : "#d0d6e8" }}
              />
              Wellness
            </button>
            <button
              className={`dept-card__tab ${tapIndex2 === 1 ? "dept-card__tab--active" : ""}`}
              onClick={() => setTapIndex2(1)}
            >
              <span
                className="dept-card__tab-dot"
                style={{ background: tapIndex2 === 1 ? "#EF8734" : "#d0d6e8" }}
              />
              Happiness
            </button>
          </div>

          {/* View all */}
          <button
            className="dept-card__view-all"
            disabled={isEmpty}
            onClick={() => navigate("/insights")}
          >
            View All
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
              <path d="M1 6.5h11M7 1.5l5 5-5 5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>

        <p className="dept-card__subtitle">Based on this month's result</p>
      </div>

      {/* ── Content ─────────────────────────────────────────── */}
      <div className="dept-card__body">
        {isEmpty ? (
          <div className="dept-card__empty">
            <img src="/img/User_empty.png" alt="" width={52} height={48} />
            <p>No department data yet</p>
          </div>
        ) : (
          activeData?.map((item: any, index: number) => (
            <div
              key={index}
              className="dept-card__row"
              onClick={() =>
                tapIndex2 === 0
                  ? navigate(`/insights_single?department=${item.department}`)
                  : navigate("/insights_single")
              }
              role="button"
              tabIndex={0}
            >
              {/* Dept name + color dot */}
              <div className="dept-card__row-top">
                <div className="dept-card__row-left">
                  <span
                    className="dept-card__dept-dot"
                    style={{ background: item?.departmentColor }}
                  />
                  <span className="dept-card__dept-name">{item?.department}</span>
                </div>
                <div className="dept-card__row-right">
                  <span
                    className="dept-card__pct"
                    style={{ color: item?.departmentColor }}
                  >
                    {item?.percentage?.toFixed(1)}%
                  </span>
                  <Image
                    src="/img/new/arrow_forward1.svg"
                    preview={false}
                    width={14}
                  />
                </div>
              </div>

              {/* Progress bar */}
              <div className="dept-card__bar-wrap">
                <Progress
                  strokeColor={item?.departmentColor}
                  trailColor="#eef0f9"
                  percent={item?.percentage}
                  status="active"
                  showInfo={false}
                  strokeWidth={6}
                />
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}